/**
 * CTR New Bundle Block — Scent Gallery Swap
 *
 * When a scent card's quantity changes, replace the main product gallery
 * (desktop + mobile) with the images from that scent's custom.carousel_images
 * metaobject (Gallery Images). If no scent is active, the original gallery
 * slides are restored.
 */
(function () {
  'use strict';

  function initScentGallery() {
    const bundleContainer = document.querySelector('.nbb-varinats-blockkk');
    if (!bundleContainer) return;

    const scentCards = bundleContainer.querySelectorAll('.nbb-single-blockkk[data-gallery]');
    if (!scentCards.length) return;

    /* ── Gallery DOM refs ── */
    const desktopViewerEl = document.querySelector('[id^="GalleryViewer-"]');
    const desktopThumbEl  = document.querySelector('[id^="GalleryThumbnails-"]');
    const mobileGalleryEl = document.querySelector('.mediaSwiper');
    const mediaGalleryEl  = desktopViewerEl ? desktopViewerEl.closest('media-gallery') : null;

    /* ── Stored originals (captured on first scent click) ── */
    let origDesktop = null;
    let origThumb   = null;
    let origMobile  = null;
    let originalsStored = false;

    function getRealSlidesHtml(wrapper) {
      if (!wrapper) return null;
      return Array.prototype.map.call(wrapper.children, function (child) {
        return child.classList.contains('swiper-slide-duplicate') ? '' : child.outerHTML;
      }).join('');
    }

    function storeOriginals() {
      if (originalsStored) return;
      if (desktopViewerEl) {
        const w = desktopViewerEl.querySelector('.swiper-wrapper');
        if (w) origDesktop = getRealSlidesHtml(w);
      }
      if (desktopThumbEl) {
        const w = desktopThumbEl.querySelector('.swiper-wrapper');
        if (w) origThumb = getRealSlidesHtml(w);
      }
      if (mobileGalleryEl) {
        const w = mobileGalleryEl.querySelector('.swiper-wrapper');
        if (w) origMobile = getRealSlidesHtml(w);
      }
      originalsStored = true;
    }

    /* ── Slide HTML builders ── */
    function buildDesktopSlides(images) {
      return images.map(function (img, i) {
        var aspect = img.w && img.h ? (img.w / img.h).toFixed(4) : '1';
        var loading = i === 0 ? 'eager' : 'lazy';
        return (
          '<div class="product__media-item swiper-slide"' +
            ' data-media-id="custom-' + i + '"' +
            ' data-swiper-slide-index="' + i + '"' +
            ' data-media-type="image"' +
            ' data-media-index="' + i + '"' +
            ' data-src="' + img.src + '">' +
            '<div class="product__media-item-container relative flex overflow-hidden blocks-radius media-type-image"' +
              ' style="--aspect-ratio:' + aspect + ';">' +
              '<img src="' + img.src + '"' +
                ' alt="' + (img.alt || '') + '"' +
                ' loading="' + loading + '"' +
                ' width="' + (img.w || '') + '"' +
                ' height="' + (img.h || '') + '"' +
                ' style="width:100%;height:auto;object-fit:cover;">' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    function buildThumbSlides(images) {
      return images.map(function (img, i) {
        return (
          '<div class="product__thumbs-item swiper-slide"' +
            ' data-target="custom-' + i + '"' +
            ' data-swiper-slide-index="' + i + '"' +
            ' data-media-position="' + (i + 1) + '">' +
            '<div class="product__thumbs-container relative blocks-radius-md media-wrapper cursor-pointer">' +
              '<div class="product__thumbs-inner" style="--aspect-ratio:1">' +
                '<img src="' + img.src + '"' +
                  ' alt="' + (img.alt || '') + '"' +
                  ' loading="lazy"' +
                  ' width="' + (img.w || '') + '"' +
                  ' height="' + (img.h || '') + '"' +
                  ' style="width:100%;height:100%;object-fit:cover;">' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    function buildMobileSlides(images) {
      return images.map(function (img, i) {
        var loading = i === 0 ? 'eager' : 'lazy';
        return (
          '<div class="swiper-slide">' +
            '<img class="mobile-media-img"' +
              ' src="' + img.src + '"' +
              ' alt="' + (img.alt || '') + '"' +
              ' loading="' + loading + '"' +
              ' width="' + (img.w || '') + '"' +
              ' height="' + (img.h || '') + '"' +
              ' style="width:100%;height:auto;">' +
          '</div>'
        );
      }).join('');
    }

    /* ── Swiper update helper ── */
    function updateSwiper(containerEl, newHtml) {
      if (!containerEl) return;
      var wrapper = containerEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;
      var swiper = containerEl.swiper;
      var isLoop = swiper && swiper.params && swiper.params.loop;

      /* Tear down loop duplicates before replacing slides so Swiper's
         internal index map stays consistent after the content change. */
      if (isLoop && typeof swiper.loopDestroy === 'function') {
        swiper.loopDestroy();
      }
      wrapper.innerHTML = newHtml;
      if (swiper) {
        swiper.update();
        /* Recreate loop duplicates and navigate to the real first slide. */
        if (isLoop && typeof swiper.loopCreate === 'function') {
          swiper.loopCreate();
          swiper.slideToLoop(0, 0);
        } else {
          swiper.slideTo(0, 0);
        }
      }
    }

    function replaceSlidesMarkup(containerEl, newHtml) {
      if (!containerEl) return;
      var wrapper = containerEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;
      wrapper.innerHTML = newHtml;
    }

    /* Rebuild media-gallery's Swiper instances after desktop slide markup changes.
       This avoids stale thumbs/main linkage after dynamic scent gallery replacement. */
    function reinitMediaGallerySwipers() {
      if (!mediaGalleryEl) return;
      try {
        if (mediaGalleryEl.sliderInstance && mediaGalleryEl.sliderInstance.slider) {
          mediaGalleryEl.sliderInstance.slider.destroy(true, true);
        }
        if (mediaGalleryEl.thumbsInstance && mediaGalleryEl.thumbsInstance.slider) {
          mediaGalleryEl.thumbsInstance.slider.destroy(true, true);
        }
      } catch (e) {}
      mediaGalleryEl.sliderInstance = false;
      mediaGalleryEl.thumbsInstance = false;
      if (typeof mediaGalleryEl.init === 'function') {
        mediaGalleryEl.init();
      }
    }

    /* Force thumbs/main linkage to a known starting slide right after swap/restore. */
    function syncThumbs() {
      var mainSwiper = desktopViewerEl && desktopViewerEl.swiper;
      var thumbSwiper = desktopThumbEl && desktopThumbEl.swiper;
      if (!mainSwiper || !thumbSwiper) return;
      if (mainSwiper.params && mainSwiper.params.loop) {
        mainSwiper.slideToLoop(0, 0);
      } else {
        mainSwiper.slideTo(0, 0);
      }
      thumbSwiper.slideTo(0, 0);
      thumbSwiper.slides.forEach(function (slide, idx) {
        slide.classList.toggle('swiper-slide-thumb-active', idx === 0);
      });
    }

    /* ── Fade helpers ── */
    var FADE_MS = 150;

    function fadeOut(el, cb) {
      if (!el) { cb(); return; }
      el.style.transition = 'opacity ' + FADE_MS + 'ms ease';
      el.style.opacity = '0';
      setTimeout(cb, FADE_MS);
    }

    function fadeIn(el) {
      if (!el) return;
      el.style.opacity = '1';
    }

    /* ── Apply / restore gallery ── */
    function applyGallery(images) {
      storeOriginals();
      var targets = [desktopViewerEl, desktopThumbEl, mobileGalleryEl];
      var remaining = targets.filter(Boolean).length || 1;

      function doSwap() {
        replaceSlidesMarkup(desktopThumbEl,  buildThumbSlides(images));
        replaceSlidesMarkup(desktopViewerEl, buildDesktopSlides(images));
        updateSwiper(mobileGalleryEl, buildMobileSlides(images));
        reinitMediaGallerySwipers();
        targets.forEach(fadeIn);
        /* Defer so syncThumbs runs after all Swiper realIndexChange callbacks settle */
        setTimeout(syncThumbs, 0);
      }

      var faded = 0;
      function onFaded() {
        faded++;
        if (faded >= remaining) doSwap();
      }

      targets.forEach(function (el) { fadeOut(el, onFaded); });
    }

    function restoreGallery() {
      if (!originalsStored) return;
      var targets = [desktopViewerEl, desktopThumbEl, mobileGalleryEl];
      var remaining = targets.filter(Boolean).length || 1;

      function doRestore() {
        function restore(el, html) {
          if (!el || html === null) return;
          var wrapper = el.querySelector('.swiper-wrapper');
          if (!wrapper) return;
          wrapper.innerHTML = html;
          var swiper = el.swiper;
          if (!swiper) return;
          swiper.update();
          /* origDesktop already contains loop clones, so use slideToLoop to land
             on the first real slide instead of the before-start clone */
          if (swiper.params && swiper.params.loop) {
            swiper.slideToLoop(0, 0);
          } else {
            swiper.slideTo(0, 0);
          }
        }
        replaceSlidesMarkup(desktopThumbEl,  origThumb);
        replaceSlidesMarkup(desktopViewerEl, origDesktop);
        restore(mobileGalleryEl, origMobile);
        reinitMediaGallerySwipers();
        targets.forEach(fadeIn);
        setTimeout(syncThumbs, 0);
      }

      var faded = 0;
      function onFaded() {
        faded++;
        if (faded >= remaining) doRestore();
      }

      targets.forEach(function (el) { fadeOut(el, onFaded); });
    }

    /* ── Gallery data helpers ── */
    function getImagesFromCard(card) {
      var raw = card.getAttribute('data-gallery');
      if (!raw) return null;
      try {
        var images = JSON.parse(raw);
        return images.length ? images : null;
      } catch (e) {
        return null;
      }
    }

    function getCardQty(card) {
      var container = card.querySelector('.flavor2_quantity-container');
      if (!container) return 0;
      return parseInt(container.getAttribute('selected-qty') || '0', 10) || 0;
    }

    /**
     * Determine which scent's gallery to show.
     * Prefers the clicked card (if it still has qty > 0),
     * then falls back to the first other active card with gallery images.
     */
    function resolveFeaturedImages(preferredCard) {
      if (getCardQty(preferredCard) > 0) {
        var images = getImagesFromCard(preferredCard);
        if (images) return images;
      }
      for (var i = 0; i < scentCards.length; i++) {
        var card = scentCards[i];
        if (card === preferredCard) continue;
        if (getCardQty(card) > 0) {
          var imgs = getImagesFromCard(card);
          if (imgs) return imgs;
        }
      }
      return null;
    }

    function onScentChange(clickedCard) {
      var images = resolveFeaturedImages(clickedCard);
      if (images) {
        applyGallery(images);
      } else {
        restoreGallery();
      }
    }

    /* ── Preload all scent gallery images on init ── */
    function preloadScentImages() {
      scentCards.forEach(function (card) {
        var raw = card.getAttribute('data-gallery');
        if (!raw) return;
        try {
          JSON.parse(raw).forEach(function (img) {
            if (img.src) {
              var el = new Image();
              el.src = img.src;
            }
          });
        } catch (e) {}
      });
    }
    preloadScentImages();

    /* ── Event delegation on the bundle container ── */
    bundleContainer.addEventListener('click', function (e) {
      var isRelevant = (
        e.target.closest('.nbb-add-btn') ||
        e.target.closest('.nbb-plus') ||
        e.target.closest('.nbb-minus')
      );
      if (!isRelevant) return;

      var card = e.target.closest('.nbb-single-blockkk');
      if (!card) return;

      /* Wait one tick so the existing qty-update handlers run first */
      setTimeout(function () { onScentChange(card); }, 0);
    });
  }

  /**
   * Mobile scent styles: tabs filter, carousel arrows, click tile → qty overlay.
   * Relies on existing add/+/− listeners in product-information-blocks.liquid.
   */
  function initMobileScentSelector() {
    var root = document.querySelector('.ctr-nbb-scents');
    if (!root) return;

    var style = root.getAttribute('data-mobile-scent-style') || 'list';
    if (style !== 'tabs' && style !== 'carousel') return;

    var track = root.querySelector('.nbb-varinats-blockkk');
    if (!track) return;

    var cards = track.querySelectorAll('.nbb-single-blockkk');

    function isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function openQty(card) {
      if (!isMobile()) return;

      var addBtn = card.querySelector('.nbb-add-btn');
      var qtyContainer = card.querySelector('.flavor2_quantity-container');
      if (!addBtn || !qtyContainer) return;

      card.classList.add('is-qty-open');

      if (qtyContainer.classList.contains('active')) return;
      if (addBtn.disabled) return;
      addBtn.click();
    }

    function closeQtyIfEmpty(card) {
      var qtyContainer = card.querySelector('.flavor2_quantity-container');
      if (!qtyContainer) return;
      var qty = parseInt(qtyContainer.getAttribute('selected-qty') || '0', 10) || 0;
      if (qty <= 0) {
        card.classList.remove('is-qty-open');
      }
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('.nbb-plus') || e.target.closest('.nbb-minus') || e.target.closest('.flavor2_quantity-container')) {
        var qtyCard = e.target.closest('.nbb-single-blockkk');
        if (qtyCard) {
          setTimeout(function () { closeQtyIfEmpty(qtyCard); }, 0);
        }
        return;
      }

      if (!isMobile()) return;

      var card = e.target.closest('.nbb-single-blockkk');
      if (!card || card.classList.contains('is-tab-hidden')) return;
      if (!root.contains(card)) return;

      e.preventDefault();
      openQty(card);
    });

    if (style === 'tabs') {
      var tabs = root.querySelectorAll('[data-scent-tab]');
      var activeTab = root.querySelector('.ctr-nbb-scents__tab--active');
      var activeSlug = activeTab ? activeTab.getAttribute('data-scent-tab') : '';

      function filterByCategory(slug) {
        cards.forEach(function (card) {
          var category = (card.getAttribute('data-scent-category') || '').trim();
          var match = !slug || !category || category === slug;
          card.classList.toggle('is-tab-hidden', !match);
        });
      }

      filterByCategory(activeSlug);

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var slug = tab.getAttribute('data-scent-tab') || '';
          tabs.forEach(function (t) {
            var isActive = t === tab;
            t.classList.toggle('ctr-nbb-scents__tab--active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          filterByCategory(slug);
          track.scrollLeft = 0;
        });
      });
    }

    if (style === 'carousel') {
      var prevBtn = root.querySelector('[data-ctr-nbb-scent-prev]');
      var nextBtn = root.querySelector('[data-ctr-nbb-scent-next]');
      var scrollAmount = 78;

      function updateNavState() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateNavState, { passive: true });
      updateNavState();
    }
  }

  /**
   * The 20px card margin clears the scrollbar. Drop it when the list fits
   * inside its max-height so the cards run flush to the edge.
   */
  function syncVariantListScrollGap() {
    document.querySelectorAll('.nbb-varinats-blockkk').forEach(function (list) {
      var overflows = list.scrollHeight > list.clientHeight + 1;
      list.classList.toggle('is-not-scrollable', !overflows);
    });
  }

  function watchVariantListScrollGap() {
    document.querySelectorAll('.nbb-varinats-blockkk').forEach(function (list) {
      if (list.dataset.scrollGapWatch === 'true') return;
      list.dataset.scrollGapWatch = 'true';
      new MutationObserver(syncVariantListScrollGap).observe(list, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
    });
    syncVariantListScrollGap();
    setTimeout(syncVariantListScrollGap, 400);
  }

  function boot() {
    initScentGallery();
    initMobileScentSelector();
    watchVariantListScrollGap();
  }

  /* ── Bootstrap ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', syncVariantListScrollGap);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
  }
})();
